<div class="row align-items-end">
  <div class="col-sm-6 text-center" *ngIf="!isGettingTanque">
    <div>
      <small id="tanque-dates" class="text-muted">
        Creado: {{ tanque.createdAt | dateFormat }} <br />
        Actualizado: {{ tanque.updatedAt | dateFormat }}
      </small>
    </div>
    <div class="divCenter gap-12">
      <button
        id="tanque-details-reject"
        type="button"
        class="btn btn-outline-danger-new my-2"
        (click)="onRejectTanque()"
        *ngIf="tanqueCanBeRejected && showButton('reject')"
      >
        Rechazar
      </button>
      <button
        id="tanque-details-approve"
        type="button"
        class="btn btn-outline-primary-new my-2"
        (click)="onApproveTanque()"
        *ngIf="tanqueNeedsApproval && showButton('approve')"
      >
        Aprobar
      </button>
    </div>
  </div>
  <div class="col-sm-6 text-end">
    <div class="btn-group" style="padding-top: 60px">
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-outline-primary dropdownButton mx-2 dropdownButton-new"
          id="tanque-details-actions"
          *ngIf="!isGettingTanque && showButton('actions')"
          ngbDropdownToggle
        >
          Acciones
          <span class="material-symbols-outlined"> keyboard_arrow_down </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownActions">
          <a
            id="tanque-details-edit"
            *ngIf="!isGettingTanque && showButton('edit')"
            (click)="onEditTanque()"
            class="dropdown-item"
            ngbDropdownItem
          >
            Actualizar documentos</a
          >
          <a
            id="tanque-details-reprocesing"
            *ngIf="!isGettingTanque && isAdmin"
            [disabled]="!isReprocesingAvailable()"
            (click)="OnReprocesiing()"
            class="dropdown-item"
            ngbDropdownItem
            >Reprocesar</a
          >
          <div class="dropdown-divider"></div>
          <a
            id="tanque-details-archive"
            *ngIf="!isGettingTanque && showButton('archive')"
            (click)="onArchiveTanque()"
            ngbDropdownItem
          >
            Archivar</a
          >
          <a
            id="tanque-details-delete"
            *ngIf="!isGettingTanque && showButton('delete')"
            (click)="onDeleteTanque()"
            ngbDropdownItem
          >
            Borrar</a
          >
        </div>
      </div>
      <button
        id="tanque-details-refresh"
        class="btn-refresh-details"
        *ngIf="!isGettingTanque"
        (click)="onRefreshTanque()"
      >
        <span class="material-symbols-outlined"> refresh </span>
      </button>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-sm-6 text-center my-5" *ngIf="isGettingTanque">
    <app-spinner message="Cargando detalles del vehículo..."></app-spinner>
  </div>
  <div
    class="col-sm-6 box-details-cab"
    [ngStyle]="{ border: '3px solid ' + getColor() }"
    *ngIf="!isGettingTanque"
  >
    <div class="div-box-sap-id">
      <h4 [ngStyle]="{ color: getColor(), 'font-weight': 'bold' }">
        SAP ID: {{ tanque.sapId! | sapId }}
      </h4>
    </div>
    <div style="display: inline">
      <p><strong>Transportista</strong>: <br />{{ tanque.carrier!.name }}</p>
      <p><strong>Patente</strong>: <br />{{ tanque.licensePlate }}</p>
      <p>
        <strong>Acoplamiento</strong>: <br />
        <span *ngIf="tanqueIsCoupled"
          >{{ coupleType }} {{ coupleIdentification }}</span
        >
        <span *ngIf="!tanqueIsCoupled">Desacoplado</span>
      </p>
    </div>
    <div *ngIf="!tanqueIsCoupled" class="text-danger divCenter">
      <p><strong>Desacoplado</strong></p>
    </div>
    <div class="divCenter" style="text-align: center">
      <p *ngIf="showBlockingMotives">
        <strong
          >Bloqueado el
          {{
            tanque.lastStatusInformedAt || tanque.updatedAt
              | dateFormat
              | dateWithoutSeconds
          }}
          por</strong
        >:<br />
        <span
          class="badge border rounded-4 text-bg-light mx-1"
          *ngFor="let motive of tanque.blockingMotives"
        >
          {{ motive }}
        </span>
      </p>
    </div>

    <div class="divCenter">
      <h5>
        <span
          class="badge"
          [ngStyle]="{ 'background-color': getColor() }"
          style="width: 200px; border-radius: 60px"
        >
          <span>
            <img
              [src]="getImageSrc(tanque.status)"
              height="25"
              width="25"
              alt="Estado"
            />
          </span>
          {{ tanque.status | master : "VEHICLES#STATUSES" }}</span
        >
      </h5>
      <div *ngIf="hasComment">
        <label
          class="custom-file-upload pt-2 mx-1 float-end text-secondary"
          style="cursor: pointer"
        >
          <a id="entity-comment" title="Comentario" (click)="onViewComment()">
            <span class="material-symbols-outlined">comment</span>
          </a>
        </label>
      </div>
    </div>
    <div class="divCenter mb-2" *ngIf="hasComment && showComment">
      <div class="collapse comment" [ngClass]="showCommentClass()">
        <div class="card card-body">
          {{ tanque.comment }}
        </div>
      </div>
    </div>

    <div class="divCenter">
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasToExpireDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            tanque.documentsToExpire
          }}</span>
          por vencer</span
        >
      </h6>
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasExpiredDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            tanque.documentsExpired
          }}</span>
          vencido</span
        >
      </h6>
    </div>

    <div ngbAccordion style="padding: 10px">
      <div ngbAccordionItem [collapsed]="true">
        <h2 ngbAccordionHeader>
          <button id="tanque-details-accordion" ngbAccordionButton>
            Ver detalles
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="table-container">
            <ng-template>
              <table class="table table-hover">
                <caption>
                  Detalles del Vehículo
                </caption>
                <tbody>
                  <tr>
                    <th scope="row">Centro</th>
                    <td>{{ tanque.originalCenter! | master : "CENTERS" }}</td>
                  </tr>
                  <tr *ngIf="business !== 'foreign'">
                    <th scope="row">Sub-Negocio</th>
                    <td>
                      {{ tanque.subBusiness | master : "SUB_BUSINESSES" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Marca</th>
                    <td>{{ tanque.brand | master : "VEHICLES#BRANDS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Modelo</th>
                    <td>{{ tanque.model }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Año de Fabricación</th>
                    <td>{{ tanque.year }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Antigüedad</th>
                    <td>
                      {{ currentYear - tanque.year }} año{{
                        currentYear - tanque.year === 1 ? "" : "s"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Color</th>
                    <td>{{ tanque.color | master : "VEHICLES#COLORS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tipo</th>
                    <td>{{ tanque.type | master : "TANQUES#TYPES" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Capacidad</th>
                    <td *ngIf="business === 'foreign'">
                      {{ tanque.capacity | customCapacity }}
                    </td>
                    <td *ngIf="business !== 'foreign'">
                      {{ tanque.capacity | master : "TANQUES#CAPACITIES" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Alto x Ancho x Largo (metros)</th>
                    <td>
                      {{ tanque.height }} x {{ tanque.width }} x
                      {{ tanque.length }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Mamparo</th>
                    <td>
                      {{
                        tanque.bulkheadType! | master : "TANQUES#BULKHEAD_TYPES"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Tiene Bomba</th>
                    <td>{{ tanque.hasPump ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Usado en Minería</th>
                    <td>{{ tanque.forMining ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Acreditación Ranchera</th>
                    <td>{{ tanque.hasRanchAccreditation ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Es Spot</th>
                    <td>{{ tanque.isSpot ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">GPS IMEI</th>
                    <td>{{ tanque.gpsImei }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Cámara IMEI</th>
                    <td>{{ tanque.cameraImei }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Código MOP</th>
                    <td>{{ tanque.MOPCode }}</td>
                  </tr>
                  <!-- only for fuels-->
                  <ng-container *ngIf="business === 'fuels'">
                    <tr>
                      <th scope="row">N° certificado SEC</th>
                      <td class="flex">
                        {{ tanque.SECCertificate }}
                        <label
                          *ngIf="showButton('edit-uses')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar N° certificado SEC"
                            (click)="
                              onUpdateTanqueFuelsAttributes('SECCertificate')
                            "
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">N° Folio inscripción SEC</th>
                      <td class="flex">
                        {{ tanque.SECFolio }}
                        <label
                          *ngIf="showButton('edit-uses')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar N° Folio inscripción SEC"
                            (click)="onUpdateTanqueFuelsAttributes('SECFolio')"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Fecha de inscripción SEC</th>
                      <td class="flex" *ngIf="tanque.SECDate">
                        {{ tanque.SECDate | date : "dd/MM/yyyy" : "UTC" }}
                        <label
                          *ngIf="showButton('edit-uses')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar Fecha de inscripción SEC"
                            (click)="onUpdateTanqueFuelsAttributes('SECDate')"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                      </td>
                    </tr>
                  </ng-container>
                  <tr>
                    <th class="align-middle" scope="row">Centro de Apoyo</th>
                    <td>
                      <div>
                        <label
                          *ngIf="showButton('edit-center')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar Centro de Apoyo"
                            (click)="onUpdateTanque()"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                        {{ tanque.center | master : "CENTERS" }}
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="tanque.uses && tanque.uses.length > 0">
                    <th class="align-middle" scope="row">Usos del vehiculo</th>
                    <td>
                      <div class="flex">
                        <label
                          *ngIf="showButton('edit-uses')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar Centro de Apoyo"
                            (click)="onUpdateTanqueUses()"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                        <ng-container *ngFor="let use of tanque.uses">
                          <span class="selected-chip">
                            {{ use }}
                          </span>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="tanque.archiveId">
                    <th scope="row">Archivo</th>
                    <td>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                      >
                        <a
                          id="archive-tanque-details"
                          title="Visualizar Detalle"
                          (click)="onViewArchiveDetails()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >docs</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="preview-archive-tanque-docs"
                          title="Visualizar Documento"
                          (click)="onViewDocumentArchive()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >preview</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="download-archive-tanque-docs"
                          title="Descargar Documento"
                          (click)="onDownloadArchiveDocument()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >download</span
                          >
                        </a>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center" *ngIf="showCapacityImage">
                <img
                  [src]="capacityImage()"
                  alt="Tanque"
                  height="200"
                  width="256"
                  (error)="showCapacityImage = false"
                />
              </div>
              <div *ngIf="!showCapacityImage" class="text-center">
                <p>Imagen no disponible</p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="hasAgrement" ngbAccordion>
      <app-commercial-agreements-details
        [agreement]="agreement"
        [isColapsed]="isColapsed"
      ></app-commercial-agreements-details>
    </div>
  </div>
  <div class="col-sm-6">
    <app-documents></app-documents>
  </div>
</div>

<!-- Modals -->
<ng-template #tanqueModal let-c="close" let-d="dismiss">
  <app-modal-with-comment
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [showCommentForm]="modalWithComment"
    [mandatoryComment]="isBeingRejected"
    [commentForm]="commentForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-with-comment>
</ng-template>

<!-- Update Attribute Modal -->
<ng-template #updateTanqueAttributeModal let-c="close" let-d="dismiss">
  <app-modal-change-attributes
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [attributeForm]="updateAttributeForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-change-attributes>
</ng-template>

<!-- Update Attribute Modal -->
<ng-template #updateTanqueAttributeUsesModal let-c="close" let-d="dismiss">
  <app-modal-change-uses
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [entityName]="'TANQUES'"
    [attributeForm]="updateAttributeForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-change-uses>
</ng-template>

<!-- Archive Modal -->
<ng-template #archiveTanqueModal let-c="close" let-d="dismiss">
  <app-modal-for-archiving
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [archiveForm]="archiveForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-for-archiving>
</ng-template>
<!--Archive Details Modal-->
<ng-template #archiveTanqueDetailsModal let-c="close" let-d="dismiss">
  <app-modal-details
    [archive]="tanqueArchive?.entity"
    [updatedAt]="tanqueArchive?.updatedAt"
    [comment]="tanqueArchive?.comment"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  >
  </app-modal-details>
</ng-template>

<!--Document Viewer Modal-->
<ng-template #archiveTanqueDocumentViewer let-c="close" let-d="dismiss">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ modalTitle }}</h4>
        <button
          id="document-item-modal-cross"
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="text-center my-5" *ngIf="isGettingURL">
          <app-spinner message="Generando Vista Previa"></app-spinner>
        </div>
        <pdf-viewer
          [src]="pdfSource"
          [render-text]="true"
          [original-size]="false"
          [fit-to-page]="true"
          (page-rendered)="pageRendered()"
          style="width: 800px; height: 70vh"
        >
        </pdf-viewer>
      </div>
      <div class="modal-footer" *ngIf="!isGettingURL">
        <button
          id="document-item-modal-accept"
          type="button"
          class="btn btn-outline-primary"
          (click)="c('Accept')"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #updateTanqueFuelsAttributesModal let-c="close" let-d="dismiss">
  <app-modal-change-fuels-attributes
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [attributeToChange]="fuelAttributeToChange"
    [attributeForm]="updateFuelsAttributesForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-change-fuels-attributes>
</ng-template>
